import React, { Component, Fragment } from 'react';
import { DateTime } from 'luxon';
import DatePicker from 'react-datepicker2';
import 'react-datepicker2/dist/react-datepicker.css';

import {
  Alert,
  Button,
  ControlLabel,
  InputGroup,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  Panel,
} from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';
import ReactSelect from 'react-select';
import { Form as FinalForm, Field, FormSpy } from 'react-final-form';
import Input from 'react-final-form-components/dist/Bs/Input';
import Radio from 'react-final-form-components/dist/Bs/Radio';

import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import _ from 'lodash';
import { FORM_ERROR } from 'final-form';

import { hours_in_timezone, snap_forward } from './DocketAlertTimeCalculations';
import { FinalFormStandaloneClientCodeAdapter } from '../../clientCode/StandaloneClientCode';
import request from 'superagent';
import { notify } from '../../components/common/Notification';

class DocketAlerts extends Component {

  // To signal error during save, onSaveSettings should resolve to DocketAlerts.saveErrorSignal(actual error)
  static saveErrorSignal = (error) => ({ [FORM_ERROR]: error });

  static defaultProps = {
    settings: { enabled: false, report_settings: {} },
  };

  static propTypes = {
    settings: PropTypes.object,
    onSaveSettings: PropTypes.func.isRequired,
    onTestAlert: PropTypes.func.isRequired,
    testProgress: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isUserAgreed: props.settings.enabled,
    };
  }

  // Convert backend settings struct to something that can be manipulated by UI for a better UX
  static settingsToForm = (settings) => _.merge({},
    settings, {
      start_time: hours_in_timezone(settings.next_run, settings.time_zone),
      report_settings: {
        // It's easier for users to edit one large list vs individual emails
        email_distribution_list: _.get(settings, 'report_settings.email_distribution_list', [])
          .join('\n'),
        // Inject blank search term so empty field shows up without users needing to click 'Add Search Term'
        docket_entry_filters: settings.report_settings.docket_entry_filters.length
          ? settings.report_settings.docket_entry_filters : [''],
      },
    });

  // Create settings object that backend understands
  static formToSettings = values =>  _.merge({},
    values, {
      next_run: snap_forward(DateTime.fromISO(values.next_run)
        .setZone(values.time_zone)
        .set({hour: values.start_time, minute: 0, second: 0, millisecond: 0 })
        .toISO(), values.time_zone),

      report_settings: {
        // massage emails back into individual entries
        email_distribution_list: _.filter(values.report_settings.email_distribution_list.split('\n')),
        // get rid of any empty values
        docket_entry_filters: _.filter(values.report_settings.docket_entry_filters),
      },
  });

  render() {
    console.log("<DocketAlerts> render()", "props", this.props, "state", this.state);

    const initialSettings = this.props.settings;

    return <FinalForm
      onSubmit={ values => this.props.onSaveSettings(DocketAlerts.formToSettings(values)) }
      initialValues={ DocketAlerts.settingsToForm(this.props.settings) }
      mutators={{
        ...arrayMutators
      }}
      render={({handleSubmit, form, submitting, pristine, values}) => (
        <Form onSubmit={handleSubmit}>

          {/*<DocketAlertsAutoSave debounce={1000} save={ this.save } />*/}
          <FormSpy
            subscription={{ valid: true, dirtyFields: true }}
            onChange={ ({valid, dirtyFields}) => {
              // Auto save "enabled"
              if ( valid && (dirtyFields.enabled || dirtyFields.next_run) ) {
                form.submit();
              }
            }}
          />

          {/*<pre>{JSON.stringify(values, null, 2)}</pre>*/}

          <Panel
            bsStyle={(this.state.isUserAgreed|| values.enabled) ? 'success' : 'warning'}
            defaultExpanded={!(this.state.isUserAgreed|| values.enabled)}
          >
            <Panel.Heading>
              <Panel.Title toggle>
                {(this.state.isUserAgreed|| values.enabled)
                  ? <Fragment>
                    <i className="fa fa-check" />{' '}
                    Docket Alert Caution: Agreed to
                  </Fragment>
                  : <Fragment>
                    <i className="fa fa-exclamation-triangle" />{' '}
                    Docket Alert Caution
                  </Fragment>
                }
              </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
            <Panel.Body>
              This automated Docket Alert will incur PACER charges while on. I will set my frequency accordingly
              and turn off the alert when no longer needed. This alert is not needed if ECF notices can be received.

              {!(this.state.isUserAgreed|| values.enabled) && <Fragment>
              <br/>
              <Button bsStyle='success' style={{float:'right'}} onClick={() => this.setState({...this.state, isUserAgreed: true})}>
                <Panel.Toggle componentClass="span">I agree</Panel.Toggle>
              </Button>
              <div style={{clear: 'both'}} />
              </Fragment>}

            </Panel.Body>
              </Panel.Collapse>
          </Panel>

          <div ref={this.props.statusPanelRef} />
          {(this.state.isUserAgreed|| values.enabled) && (<Fragment>
          <Panel bsStyle={ values.enabled ? "success" : "danger"}>
            <Panel.Heading>
              <Panel.Title>
                {values.enabled &&
                <div style={{ float: 'right' }}>
                  {submitting
                    ? <i className="fa fa-circle-o-notch fa-spin" />
                    : <Field
                      name="enabled"
                      component={ToggleAdapter}
                      size="xs"
                      onstyle={"success"}
                      offstyle={"danger"}
                    />
                  }
                </div>
                }
                Status
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              {initialSettings.enabled ?
                <AlertCurrentSettings settings={initialSettings} />
                :
                <p>
                  Automated docket updates and alerts are not enabled. Configure and test your alert below before turning on.
                </p>
              }
            </Panel.Body>
          </Panel>


        <div>
          <Panel>
            <Panel.Heading>
              <Panel.Title>
                <i className="fa fa-clock-o" />{ ' ' }
                Frequency Settings

                <SaveButton form={form} pristine={pristine} submitting={submitting} values={values} />
              </Panel.Title>
            </Panel.Heading>
            <Panel.Heading style={{backgroundColor: '#fcf8e3',}}>
              <i className="fa fa-exclamation-triangle" />
              { ' ' }
                 Docket alerts incur PACER charges.
              Select your frequency accordingly and remember to turn off your alert when no longer needed.
            </Panel.Heading>
            <Panel.Body style={{lineHeight: '32px' }}>

              Update docket
              <div style={{  display: 'inline-block',  marginLeft: '16px',  marginRight: '16px', verticalAlign: 'middle'}}>
                <Field
                  name="frequency"
                  component={ReactSelectAdapter}
                  placeholder=""
                  style={{width: '150px'}}
                  options={['P1D', 'P2D', 'P3D', 'P7D'].map(period => (
                    { value: period, label:  period2string(period) }
                  ))}
                  clearable={false}
                />
              </div>
              at
              <div style={{  display: 'inline-block',  marginLeft: '16px', verticalAlign: 'middle'}}>
                  <Field
                    name="start_time"
                    component={ReactSelectAdapter}
                    placeholder=""
                    style={{width: '150px'}}
                    options={[
                      { value:  0, label: "12 am", },
                      { value:  1, label:  "1 am", },
                      { value:  2, label:  "2 am", },
                      { value:  3, label:  "3 am", },
                      { value:  4, label:  "4 am", },
                      { value:  5, label:  "5 am", },
                      { value:  6, label:  "6 am", },
                      { value:  7, label:  "7 am", },
                      { value:  8, label:  "8 am", },
                      { value:  9, label:  "9 am", },
                      { value: 10, label: "10 am", },
                      { value: 11, label: "11 am", },
                      { value: 12, label: "12 pm", },
                      { value: 13, label:  "1 pm", },
                      { value: 14, label:  "2 pm", },
                      { value: 15, label:  "3 pm", },
                      { value: 16, label:  "4 pm", },
                      { value: 17, label:  "5 pm", },
                      { value: 18, label:  "6 pm", },
                      { value: 19, label:  "7 pm", },
                      { value: 20, label:  "8 pm", },
                      { value: 21, label:  "9 pm", },
                      { value: 22, label: "10 pm", },
                      { value: 23, label: "11 pm", },
                      ]}
                    clearable={false}
                  />
                  </div>
                  <div style={{  display: 'inline-block', marginLeft: '16px', verticalAlign: 'middle'}}>

                  <Field
                    name="time_zone"
                    component={ReactSelectAdapter}
                    placeholder={values.time_zone || 'Select a time zone'}
                    style={{width: '250px'}}
                    options={[
                      { label: 'US/Alaska',         value: 'America/Anchorage'            },
                      { label: 'US/Aleutian',       value: 'America/Adak'                 },
                      { label: 'US/Arizona',        value: 'America/Phoenix'              },
                      { label: 'US/Central',        value: 'America/Chicago'              },
                      { label: 'US/Eastern',        value: 'America/New_York'             },
                      { label: 'US/East-Indiana',   value: 'America/Indiana/Indianapolis' },
                      { label: 'US/Hawaii',         value: 'Pacific/Honolulu'             },
                      { label: 'US/Indiana-Starke', value: 'America/Indiana/Knox'         },
                      { label: 'US/Michigan',       value: 'America/Detroit'              },
                      { label: 'US/Mountain',       value: 'America/Denver'               },
                      { label: 'US/Pacific',        value: 'America/Los_Angeles'          },
                      { label: 'US/Samoa',          value: 'Pacific/Pago_Pago'            },
                    ]}
                    clearable={false}
                  />
                  </div>
              <br/>
              { /*<!-- respecting Daylight Savings when applicable --> */ }

            </Panel.Body>
          </Panel>


          <Panel>
            <Panel.Heading>
              <Panel.Title>
                <i className="fa fa-gear" />{ ' ' }
                Update Options
                <SaveButton form={form} pristine={pristine} submitting={submitting} values={values} />
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>

              <FormGroup>
                <ControlLabel>Client Code</ControlLabel>{' '}
                <FormControl.Static componentClass="div">
                  <Field
                    name="client_code"
                    component={FinalFormStandaloneClientCodeAdapter}
                  />
                </FormControl.Static>
                <HelpBlock>
                  The selected client code will be used to make PACER purchases.
                </HelpBlock>
              </FormGroup>

              <FormGroup>
                <ControlLabel>Docket Header</ControlLabel>
                {/*<FormControl.Static componentClass="div">*/}
                  <Radio name="minimize_header">
                    <option value={false}>
                      Full
                    </option>
                    <option value={true}>
                      Minimize
                    </option>
                  </Radio>
                {/*</FormControl.Static>*/}
                <FormControl.Feedback />
                <HelpBlock>
                  If up-to-date docket header is not important to you,
                  select "Minimize" to save costs on cases with long headers.
                </HelpBlock>
              </FormGroup>


            </Panel.Body>
          </Panel>


          <Panel>
            <Panel.Heading>
              <Panel.Title>
                <i className="fa fa-bell" />{ ' ' }
                Notification Preferences
                <SaveButton form={form} pristine={pristine} submitting={submitting} values={values} />
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>

              <Radio name="report_settings.email_mode">
                <option value="never">
                  Do not send me any emails, just update the docket for me
                </option>
                <option value="always">
                  Email whenever docket alert is run (even when nothing new found)
                </option>
                <option value="new">
                  Email new docket entries (only when new entries found)
                </option>
                <option value="matching">
                  Email only new docket entries that meet the following criteria:
                </option>
              </Radio>


              { _.get(values, 'report_settings.email_mode') === "matching" && <FormGroup>
                <FieldArray name="report_settings.docket_entry_filters">
                  {({fields}) => fields.map((name, index) => (
                      <InputGroup key={index}>
                        <Input type="text" name={name} placeholder="Docket text search term to be matched" />
                        <InputGroup.Button>
                          <Button onClick={() => fields.remove(index)}>
                            ❌
                          </Button>
                        </InputGroup.Button>
                      </InputGroup>
                    ))}
                </FieldArray>
                <Button
                  bsStyle="link"
                  bsSize="small"
                  onClick={() => form.mutators.push('report_settings.docket_entry_filters', '')}
                >
                  + Add Search Term
                </Button>
              </FormGroup>}


              {/*<Panel>*/}
              {/*  <Panel.Heading>*/}
              {/*    <Panel.Title>*/}
              {/*      <i className="fa fa-envelope" />{ ' ' }*/}
              {/*      Distribution List*/}
              {/*    </Panel.Title>*/}
              {/*  </Panel.Heading>*/}
              {/*  <Panel.Body>*/}

              { _.get(values, 'report_settings.email_mode') !== "never" &&
                <FormGroup>
                    <InputGroup>
                      <ControlLabel><i className="fa fa-envelope" /> Send docket alert emails to the following distribution list</ControlLabel>
                      {/*<FormControl componentClass="textarea" name="report_settings.email_distribution_list" />*/}
                      <Input type="textarea" name="report_settings.email_distribution_list" />
                    </InputGroup>
                </FormGroup>
              }

              {/*  </Panel.Body>*/}
              {/*</Panel>*/}

            </Panel.Body>
          </Panel>


          {/* Test Alert Settings Panel */}
          { <Panel>
            <Panel.Heading>
              <Panel.Title>
                <i className="fa fa-play-circle" />{ ' ' }
                Test Settings
              </Panel.Title>
            </Panel.Heading>
            <Panel.Heading style={{backgroundColor: '#fcf8e3',}}>
              <i className="fa fa-exclamation-triangle" />
              { ' ' }
              It is recommended that you test your docket alert when changing the configuration. PACER Charges Apply.
            </Panel.Heading>
            <Panel.Body>

              {
              <FinalForm
                initialValues={ {update_full_docket: false} }
                onSubmit={(testConfig) => this.props.onTestAlert(DocketAlerts.formToSettings(values), testConfig) }
                render={({ form: testForm }) => (
                  <div>

                    <FormGroup>
                      <Radio name="update_full_docket">
                        <option value={false}>
                          Test by updating as of last known filed date
                        </option>
                        <option value={true}>
                          Test by updating full docket
                        </option>
                      </Radio>
                    </FormGroup>

                    <Button
                      disabled={ !! this.props.testStatus.testProgressViewComponent }
                      bsStyle="primary"
                      onClick={() => testForm.submit() }
                    >
                      {this.props.testStatus.testProgressViewComponent
                        ? <i className="fa fa-play-circle fa-spin" />
                        : <i className="fa fa-play-circle" />
                      }{ ' ' }
                      { values.enabled
                        ? 'Test and Save Docket Alert'
                        : 'Test and Activate Docket Alert'
                      }
                    </Button>
                    <p></p>

                    { this.props.testStatus.testProgressViewComponent &&
                    <Alert bsStyle="info">
                      <h4>Testing in progress...</h4>
                      {this.props.testStatus.testProgressViewComponent}
                    </Alert>
                    }

                  </div>
                  )}
                />}

                <p></p>
              {this.props.testStatus.testError &&
              <Alert bsStyle="danger">
                <h4>Error running alert</h4>
                <p>Please correct the error and try again. Contact us if problem pesists. Details:</p>
                <pre>{ "" + this.props.testStatus.testError}</pre>
              </Alert>
              }

              {this.props.testStatus.isTestSuccessful && pristine &&
              (initialSettings.enabled
                  ? <Alert bsStyle="success">
                      <h4>Test Successful, alert up to date</h4>
                      <p>
                        <AlertCurrentSettings settings={values} />
                      </p>
                    </Alert>
                  : <p>
                    <Alert bsStyle="info">
                      <h4>Your alert tested successfully, turning on...</h4>

                    </Alert>
                  </p>
              )}


            </Panel.Body>
          </Panel>}


        </div>
          </Fragment>)}
          <a href='#' onClick={ (e) => { alert(JSON.stringify(values, null, 2)); e.preventDefault() } }>Inspect Raw Settings</a>
        </Form>
      )} />; // end FinalForm render function
  }
}

const ToggleAdapter = ({ input: { onChange, value }, ...rest }) => (
  <Toggle
    active={!!value}
    onClick={() => onChange(!value)}
    {...rest}
  />
);

const ReactSelectAdapter = ({ input, ...rest }) => (
  <ReactSelect {...input} {...rest} simpleValue />
);

const LinkDateInput = ({value, onClick}) => (
  <Button bsStyle="link" bsSize="xs" onClick={onClick}>
    <i className="fa fa-calendar" />{ ' ' }
    {DateTime.fromFormat(value, 'D').toFormat('DDDD')}
  </Button>
);

const ReactDatePickerAdapter = ({ input: {onChange, value}, ...rest }) => (
  <DatePicker
    selected={DateTime.fromISO(value).toJSDate()}
    onChange={newDate => onChange(DateTime.fromJSDate(newDate).toISODate())}
    customInput={<LinkDateInput />}
    {...rest}
  />
);

const AlertCurrentSettings = ({ settings }) => {
  try {
    const next_run = DateTime.fromISO(settings.next_run).setZone(settings.time_zone);
    return (
      <span>
        Alert will run be <strong>{period2string(settings.frequency)}</strong>
        {' '} at <strong>{next_run.toFormat('t ZZZZ')}</strong>.
        {' '} Next run is scheduled for <strong>{next_run.toRelativeCalendar()}</strong>
        {' '} on <div style={{ display: 'inline-block' }}>
                <Field
                  name="next_run"
                  component={ReactDatePickerAdapter}
                  placeholderText="Select a starting Date"
                  minDate={new Date()}
                  todayButton="Today"
                />
              </div> (click to reschedule)
      </span>
    );
  } catch (error) {
    return <Alert bsStyle="danger">There was an error calculating time period: { `${error}` }</Alert>
  }
};

const SaveButton = ({ values, form, pristine, submitting} ) => (
  // We can only trigger the save when form is already enabled
  values.enabled
    ? <span>
        <Button
          style={{ float: 'right' }}
          bsStyle={pristine ? 'default' : 'success'}
          bsSize="xs"
          // instaed of type=submit, since we dont' want stray [Enter] to submit the form
          onClick={() => form.submit()}
          disabled={submitting || pristine}
        >
          Save
          {' '}{submitting && <i className="fa fa-circle-o-notch fa-spin" />}
        </Button>
        <div style={{ clear: 'both' }} />
      </span>
    : null
);

const period2string = period => ({
  'P1D': 'daily',
  'P2D': 'every 2 days',
  'P3D': 'every 3 days',
  'P7D': 'weekly',
}[period] || period)

export default DocketAlerts;



// WEBPACK FOOTER //
// ./src/CaseFolder/Settings/DocketAlerts.jsx